import { useRouter } from "@tanstack/react-router";
import { locale as datesLocale } from "dayjs";
import { useTranslation } from "react-i18next";

import { useAuth } from "@/api/resources/auth/hooks";
import LocaleSelector, { type LocaleSelectorProps } from "@/components/Locale/LocaleSelector";

interface LocaleSelectorGlobalProps extends LocaleSelectorProps {
  collapsed?: boolean;
}
export const LocaleSelectorGlobal = ({ collapsed = true, ...props }: LocaleSelectorGlobalProps) => {
  const router = useRouter();
  const { user_id, updateAuthUserProfile, loadingUpdateAuthUserProfile } = useAuth();
  const { i18n } = useTranslation();

  const currentLocale = i18n.resolvedLanguage;

  const onLocaleChange = async (locale: string | null) => {
    if (locale) {
      await i18n.changeLanguage(locale);
      await router.invalidate();

      datesLocale(locale);
      if (user_id) {
        updateAuthUserProfile({
          id: user_id,
          locale,
        });
      }
    }
  };

  return (
    <LocaleSelector
      w={collapsed ? "8rem" : undefined}
      size={collapsed ? "xs" : undefined}
      required
      value={currentLocale}
      loading={loadingUpdateAuthUserProfile}
      onChange={onLocaleChange}
      {...props}
    />
  );
};

export default LocaleSelectorGlobal;
